<template>
  <div id="app">
    <index />
    <!-- Chatbot Icon -->
    <div class="chatbot-icon" id="chatbot-icon">
      <!-- <img style="width:50px;" src="https://main-v2.dg275ieb6yp8i.amplifyapp.com/img/avatar.90c2b778.png"/> -->
      <LottieAnimation
        :animationData="bot_avatar"  
        :auto-play="true"            
        :loop="true"       
        :speed="20"                   
        class="lottie-container"     
        ref="anim"
        :width="400"
      />
    </div>

    <!-- Chatbot Window -->
    <div class="chatbot-window" id="chatbot-window">
      <div id="minimize-btn" class="chatbot-header">
        <img style="width:40px;" src="https://main-v2.dg275ieb6yp8i.amplifyapp.com/img/avatar.90c2b778.png"/>
        <i class="el-icon-minus" style="font-size:20px; color: #6b69a8; font-weight: 900;"></i>
      </div>
      <div class="chatbot-content">
        <iframe id="chatBotBody" :src="bot_url"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */ 
import Index from './components/Index.vue'
import LottieAnimation from 'lottie-web-vue';  // Import the Lottie component
import avatar_lottie from './assets/images/avatar_lottie.json';  // Import the Lottie JSON file

export default {
  name: 'App',
  components: {
    Index,
    LottieAnimation,
  },
  data() {
    return {
      verification: false,
      token: '',
      isChatbotOpen: false,
      bot_avatar: avatar_lottie,  // Store the Lottie animation JSON data
      animationDelay: 2000,
      bot_url: process.env.VUE_APP_BOT_URL
    };
  },
  created() {},
  beforeCreate() {
    document.title = 'E learning';
  },
  mounted() {
    const chatbotIcon = document.getElementById('chatbot-icon');
    const chatbotWindow = document.getElementById('chatbot-window');
    const minimizeBtn = document.getElementById('minimize-btn');

    chatbotIcon.addEventListener('click', () => {
      chatbotWindow.classList.toggle('open');
    });

    minimizeBtn.addEventListener('click', () => {
      chatbotWindow.classList.remove('open');
    });
    console.log(this.bot_avatar, 'bot');
  },
  methods: {
    onAnimationComplete() {
      setTimeout(() => {
        this.$refs.anim.play(); // Restart animation after delay
        console.log('play')
      }, 2000); // Delay time in ms
    },
  },
};
</script>

<style>
.chatbot-icon {
  position: fixed;
  bottom: 10px;
  left: 10px;
  cursor: pointer;
  border-radius: 50%;
  /* box-shadow: 0px -4px 10px rgb(255 255 255 / 20%); */
}

.chatbot-window {
  border-radius: 5px;
  overflow: hidden;
  position: fixed;
  bottom: 10px;
  left: 10px;
  width: 60%;
  height: 80%;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
  opacity: 0;
  transform: translateY(100px);
  transition: opacity 0.3s ease, transform 0.3s ease;
  display: flex;
  flex-direction: column;
  pointer-events: none;
}

.chatbot-window.open {
  opacity: 1;
  transform: translateY(0);
  pointer-events: auto;
}

.chatbot-header {
  background-image: radial-gradient(farthest-corner at 40px 40px, #110f30 0%, #2C274F 100%);
  padding: 10px 20px;
  color: #fff;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid rgb(255 255 255 / 13%);
}

.chatbot-content {
  flex: 1;
}

button {
  background: none;
  color: #fff;
  border: none;
  font-size: 18px;
  cursor: pointer;
}

#chatBotBody {
  width: 100%;
  height: 100%;
  border: none;
}

button:focus {
  outline: none;
}

#minimize-btn {
  cursor: pointer;
}
</style>
